import React from "react";
import { useBrand } from "./BrandContext";
const { getDefaultBrand } = require("../../../shared/branding");

const BRAND_TOKEN_PATTERN =
  /(HomeHelper\.com|HomeHelper\.ai|HomeHelper-defined|HomeHelper|Home Helper|Home-Helper\.com|Home-Helper Marketplace™|Home-Helper Marketplace|Home-Helper's|Home-Helper)/g;

function isDomainToken(token) {
  return /\.com$/i.test(token);
}

function isPossessiveToken(token) {
  return /'s$/i.test(token);
}

function isMarketplaceToken(token) {
  return /Marketplace/i.test(token);
}

function isDefinedAreaToken(token) {
  return /defined$/i.test(token);
}

export function getBrandedPlainText(text, brand) {
  if (!text || typeof text !== "string") {
    return text;
  }

  const safeBrand = brand?.brandName ? brand : getDefaultBrand();

  return text.replace(BRAND_TOKEN_PATTERN, (token) => {
    let value = `${safeBrand.brandName}™`;

    if (isDomainToken(token)) {
      value += ".com";
    } else if (/\.ai$/i.test(token)) {
      value = `${safeBrand.brandName}™`;
    }

    if (isMarketplaceToken(token)) {
      value += " Marketplace";
    }

    if (isDefinedAreaToken(token)) {
      value += "-defined";
    }

    if (isPossessiveToken(token)) {
      value += "'s";
    }

    return value;
  });
}

export function BrandMark({ brand: brandProp, domain = false, marketplace = false, possessive = false }) {
  const contextBrand = useBrand();
  const brand = brandProp || contextBrand;

  return (
    <>
      {brand.brandName}
      <sup>TM</sup>
      {domain ? ".com" : ""}
      {marketplace ? " Marketplace" : ""}
      {possessive ? "'s" : ""}
    </>
  );
}

export function renderBrandedText(text, brand) {
  if (!text || typeof text !== "string") {
    return text;
  }

  return text.split(BRAND_TOKEN_PATTERN).map((part, index) => {
    if (!part) {
      return null;
    }

    if (!BRAND_TOKEN_PATTERN.test(part)) {
      BRAND_TOKEN_PATTERN.lastIndex = 0;
      return part;
    }

    BRAND_TOKEN_PATTERN.lastIndex = 0;

    if (isDefinedAreaToken(part)) {
      return (
        <React.Fragment key={index}>
          <BrandMark brand={brand} />
          -defined
        </React.Fragment>
      );
    }

    return (
      <BrandMark
        key={index}
        brand={brand}
        domain={isDomainToken(part)}
        marketplace={isMarketplaceToken(part)}
        possessive={isPossessiveToken(part)}
      />
    );
  });
}

export default function BrandText({ children }) {
  const brand = useBrand();
  return <>{renderBrandedText(children, brand)}</>;
}
